import { createApp, h, ref } from 'vue';
import { createI18n } from 'vue-i18n';
import { createPinia, getActivePinia } from 'pinia';
import dashboardStore from 'dashboard/store';
import WhatsAppCallRealtimeHost from 'dashboard/components-next/Conversation/WhatsAppCallRealtimeHost.vue';
import i18nMessages from 'dashboard/i18n';
import {
  datetimeFormats,
  numberFormats,
  pluralRules,
} from 'dashboard/i18n/formats';

const TERMINAL_STATUSES = new Set(['rejected', 'ended', 'failed', 'missed']);

let host = null;

const createRealtimeI18n = () =>
  createI18n({
    legacy: false,
    locale: 'pt_BR',
    fallbackLocale: 'en',
    messages: i18nMessages,
    pluralRules,
    numberFormats,
    datetimeFormats,
  });

const ensureHost = () => {
  if (host || typeof document === 'undefined') return host;

  const root = document.createElement('div');
  root.dataset.whatsappCallHost = 'true';
  document.body.appendChild(root);

  const hostRef = ref(null);
  const app = createApp({
    setup() {
      return () => h(WhatsAppCallRealtimeHost, { ref: hostRef });
    },
  });
  app.use(createRealtimeI18n());
  app.use(dashboardStore);
  app.use(getActivePinia() || createPinia());
  app.mount(root);

  host = {
    present: payload => hostRef.value?.present(payload) || false,
  };
  return host;
};

export const presentIncomingWhatsappCall = payload => {
  const call = payload?.call;
  if (!call?.id || call.direction !== 'inbound') return false;
  if (TERMINAL_STATUSES.has(String(call.status).toLowerCase()) && !host) {
    return false;
  }

  return ensureHost()?.present(payload) || false;
};

export const resetWhatsappCallRealtimeHost = () => {
  host = null;
};
